export default __webpack_public_path__ + "css/adminImport.bundle.css";